import React from "react";

const StyledBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      style={{
        height: "96vh",
        width: "96vw",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 4,
      }}>
      {children}
    </div>
  );
};
export default StyledBody;
